export default function (actionType, actionPayload, currentLocation, currentCredits) {
   let creditChange = 0;
   if ((actionType === 'units/addCurriculumItem' || actionType === 'units/removeCurriculumItem')
      && actionPayload != null
      && actionPayload.relationship
      && actionPayload.relationship.type === 'Unit'
      && actionPayload.location
      && actionPayload.location.startsWith(currentLocation) )
   {
      switch (actionType) {
         case 'units/addCurriculumItem':
            creditChange = parseInt(actionPayload.relationship.credits) || 0;
            break
         case 'units/removeCurriculumItem':
            creditChange = -parseInt(actionPayload.relationship.credits) || 0;
            break
      }
   }
   return Math.max(0, currentCredits + creditChange);
}
